import { Typography } from "@mui/material";
import { PericiaInvoiceItem } from "../../../../entities/pericia";
import { PericiasListByDateComponent } from "./pericias-list-by-date-component";
import { PericiasListByDateDisplayFieldsToggler } from "./pericias-list-by-date-display-fields";
import { ListPericiasByDatePDFDownload } from "./list-pericias-by-date-pdf-download.component";

interface ListPericiasByCostumerListProps {
  props: {
    pericias: PericiaInvoiceItem[];
    selectedFieldsToDisplay: {
      displayPlate: boolean;
      displayChassis: boolean;
      displayDate: boolean;
      displayPrice: boolean;
      displayUserName: boolean;
      displayTotalHours: boolean;
    };
    totalPrice: number;
    totalCostumers: number;
    start: Date;
    end: Date;
    fetchedAll: boolean;
    listLoading: boolean;
    handleFetchNextPage: () => void;
    handleSelectedFieldsToDisplayChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    filter: string; // For the PDF filter prop
  };
}

export const PericiasListByDate: React.FC<ListPericiasByCostumerListProps> = ({ props }) => {
  const {
    pericias,
    selectedFieldsToDisplay,
    totalPrice,
    totalCostumers,
    start,
    end,
    handleFetchNextPage,
    fetchedAll,
    listLoading,
    handleSelectedFieldsToDisplayChange,
    filter
  } = props;

  const totalPericias = pericias.length;

  if (totalPericias === 0) return <></>;

  return (
    <>
      <PericiasListByDateDisplayFieldsToggler
        props={{
          selectedFieldsToDisplay,
          toggleDisplay: handleSelectedFieldsToDisplayChange
        }}
      />
      <Typography variant="subtitle1" component="p">
        Utilize o celular com a tela deitada para visualizar a lista*
      </Typography>
      <PericiasListByDateComponent
        props={{
          pericias,
          selectedFieldsToDisplay,
          totalPrice,
          totalCostumers,
          fetchedAll,
          listLoading,
          handleFetchNextPage
        }}
      />
      <ListPericiasByDatePDFDownload
        props={{
          pericias,
          filter,
          start,
          end,
          totalPrice,
          displayFields: selectedFieldsToDisplay
        }}
      />
    </>
  );
};
